import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesNotificationSchemeDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-notification-scheme-delete',
	path: '/secure/admin/DeleteNotificationScheme([!%]?[\\w]*).jspa',
};
